import React, { useEffect, useState } from "react";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import downloadIcon from '../../assets/images/down1.png';

const PdfPreview = ({ fileUrl,handleDownload }) => {
    const [pdfUrl, setPdfUrl] = useState(fileUrl);

    useEffect(() => {
        setPdfUrl(fileUrl);
    }, [fileUrl]);

    const defaultLayoutPluginInstance = defaultLayoutPlugin({
        renderToolbar: (Toolbar) => (
            <Toolbar>
                {(props) => {
                    const {
                        ZoomIn,
                        ZoomOut,
                        GoToNextPage,
                        GoToPreviousPage,
                        EnterFullScreen,
                        Print,
                        CurrentPageInput,
                        NumberOfPages,
                    } = props;

                    return (
                        <>
                            <GoToPreviousPage />
                            <CurrentPageInput /> / <NumberOfPages />
                            <GoToNextPage />
                            <ZoomOut />
                            <ZoomIn />
                            <Print />
                            <EnterFullScreen />
                            <button title="Download" style={{cursor:'pointer',border:'none'}} onClick={handleDownload}>
                                <img width='22px' height='22px' src={downloadIcon} alt="" />
                            </button>
                        </>
                    );
                }}
            </Toolbar>
        ),
    });

    return (
        <div style={{ height: "54vh", width: "99.6%", overflowY: "auto", marginBottom: "2%", display: "flex", justifyContent: "center", fontWeight: "bold" }}>
            {pdfUrl ? (
                <Worker workerUrl={`https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js`}>
                    <Viewer fileUrl={pdfUrl} plugins={[defaultLayoutPluginInstance]} />
                </Worker>
            ) : (
                <p>No PDF to display</p>
            )}
        </div>
    );
};

export default PdfPreview;
